import type { IconSvgObject } from './types';

const BeakerIcon: IconSvgObject = [
  ["path", { d: "M4.5 19V4C4.5 3.44772 4.94772 3 5.5 3H18.7929C19.1834 3 19.5 3.31658 19.5 3.70711C19.5 3.89464 19.4255 4.0745 19.2929 4.20711L17.7929 5.70711C17.6054 5.89464 17.5 6.149 17.5 6.41421V19C17.5 20.1046 16.6046 21 15.5 21H6.5C5.39543 21 4.5 20.1046 4.5 19Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4.5 14H17.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default BeakerIcon;
